import { dateFormatMap } from '@op/constants';
import { formatTime, toPercentNumber } from '../../render-helper';

export default function (params: any) {
  const { date_type } = params;
  return [
    {
      renderHelper: [formatTime(dateFormatMap[date_type])],
      header: 'Date',
      render: 'time',
    },
    {
      header: 'Positive',
      render: 'select_recommend',
    },
    {
      header: 'Negative',
      render: 'select_non_recommend',
    },
    {
      header: `Positive%`,
      render: 'select_recommend_score',
      renderHelper: [toPercentNumber(true)],
      numFmt: '0%',
    },
  ];
}
